export default __webpack_public_path__ + "static/media/photo-1438761681033-6461ffad8d80.613ac608.jpeg";